<shared-modal-container
  [headline]="dialogData?.header ?? ''"
  (closeModal)="cancel()"
  [isDialogPositionUp]="isDialogPositionUp">
  <div class="bg-light px-4 pb-4 w-100">
    <ng-container [ngTemplateOutlet]="dialogData?.customTemplate ?? null" />

    <div class="flex-column p-3 gap-3">
      <button pButton class="m-a p-button p-button-outline centered w-100" (click)="cancel()">
        Close
      </button>
    </div>
  </div>
</shared-modal-container>
